// eslint-disable-next-line no-unused-vars
import React, { memo, useState } from 'react';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { API_PRODUCTS } from 'Constants';
import useToastNotifications from 'Hooks/useToastNotifications';
import useFetch from 'Hooks/useFetch';
import ProductPriceRequestComponent from 'Components/Products/ProductPriceRequest';

const ProductPriceRequest = memo(({ productId }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const toast = useToastNotifications();
  const fetcher = useFetch();

  const handlePriceRequest = () => {
    setLoading(true);
    fetcher(`${API_PRODUCTS}/${productId}/request-price`, {
      method: 'POST'
    })
    .then(() => {
      toast.addNotification({
        type: 'success',
        title: t('products.priceRequestSuccessTitle'),
        message: t('products.priceRequestSuccessText')
      });
    })
    .catch(err => {
      const messages = (err.info.errors || []).map(i => i?.message).join('\r\n');
      toast.addNotification({
        type: 'error',
        title: messages
      });
    })
    .finally(() => setLoading(false));
  };

  return (
    <ProductPriceRequestComponent
      loading={ loading }
      handlePriceRequest={ handlePriceRequest }
    />
  );
});

ProductPriceRequest.propTypes = {
  productId: string,
};

export default ProductPriceRequest;
